enum UserStatus {
  INVITED = 0,
  ACTIVE = 1,
  INACTIVE = 2,
}

export { UserStatus };
